import { Box, Button, chakra, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const NoAccountsCard: FC = (props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <AppCard
      minH="130px"
      p="15px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      bgImage="linear-gradient(180deg, #40D9B5 0%, #018949 100%)"
      bgColor={Color.Primary500}
      {...props}
    >
      <Text color={Color.OnPrimary} mb="10px">
        {t('noAccountsDescription')}
      </Text>
      <Box>
        <Button
          variant={ButtonVariant.Light}
          onClick={() => navigate(AppRoute.createBrokerAccount)}
        >
          {t('noAccountsAction')}
        </Button>
      </Box>
    </AppCard>
  );
};

export default chakra(NoAccountsCard);
